import React, { createContext, useState, useEffect } from "react"
import Menu from "./Menu"
import ToggleIcon from "../assets/svg/toggle.svg"
import Logo from "../assets/svg/logo.svg"
import firebase from 'gatsby-plugin-firebase'
import useAuthState from '../functions/useAuthState'
// import { AuthContext } from '../context/auth'
import { navigate, Link } from 'gatsby'

const BlogHeader = ({ pageContext, toggleBackdrop, user, ...props }) => {
  const [state, setState] = useState({
    email: '',
    password: '',
    error: null
  })

 // const [user, loading, error] = useAuthState(firebase)

  // const { setUser } = useContext(AuthContext)

  const handleChange = e => {
    const value = e.target.value
    setState({ 
      ...state,
      [e.target.name]: value
    })
  }

  useEffect(() => {
    if (user) {
      navigate('/my-account');
    }
  })



  var canUseDOM = !!(
    (typeof window !== 'undefined' && window.document && window.document.createElement)
  );



  return (
    <div className="blog-header">
        <h6>
          Visual Forester Community
        </h6>
      <div className="auth">

          <p>
			Visual Forester is proud to be an integral part of the forestry community. Share your use cases, collaborate with other industry professionals, or share app insights in our dedicated forums.
			<br></br>

          </p>

		</div>
    </div>
  )
}

export default BlogHeader
